"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditPunchStep = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const context_1 = require("../../../../../components/PunchWorkflow/context");
const PunchWorkflowTypes_1 = require("../../../../../components/PunchWorkflow/PunchWorkflowTypes");
const consts_1 = require("../../../../../consts");
const hooks_1 = require("../../../../../hooks");
const PunchModalTypes_1 = require("../../../../../components/PunchModal/PunchModalTypes");
const PunchDetailsModalTypes_1 = require("../../../../../components/PunchDetailsModal/PunchDetailsModalTypes");
const useEditPunchStep = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { associateInfo, selectedDateTime, selectedPunchTime, action, addPunchLockedOutStatus, newPunchDate, newPunchTime, useMilitaryTime, setTotalSteps, setCurrentStepTitle, setIsCurrentStepValid, setShowErrorFallback, setIsActionable, setNewPunchTime, setAddPunchLockedOutStatus, setUseMilitaryTime } = (0, context_1.usePunchWorkflowContext)();
    const isAddPunch = action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.ADD;
    const isEditPunch = action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.EDIT;
    const [punchDate, setPunchDate] = react_1.default.useState(newPunchDate ||
        (isEditPunch
            ? luxon_1.DateTime.fromISO(selectedPunchTime === null || selectedPunchTime === void 0 ? void 0 : selectedPunchTime.punchDateTime.timestamp)
            : selectedDateTime));
    const [punchTime, setPunchTime] = react_1.default.useState(newPunchTime || '');
    const [hasInputError, setHasInputError] = react_1.default.useState(false);
    const [inputErrorMessage, setInputErrorMessage] = react_1.default.useState('');
    (0, react_1.useEffect)(() => {
        if (isEditPunch) {
            setTotalSteps(5);
            setCurrentStepTitle(t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_EditTitle'));
        }
        else {
            setTotalSteps(4);
            setCurrentStepTitle(t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_AddTitle'));
        }
        setShowErrorFallback(false);
        setIsActionable(true);
        return () => {
            setIsActionable(true);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        setIsCurrentStepValid(punchTime && punchDate && punchDate.isValid && !hasInputError);
    }, [punchTime, punchDate, hasInputError, setIsCurrentStepValid]);
    const { isLoading: isMissedPunchLockoutStatusLoading, data: { associateAipLockoutStatus } = {}, error: missedPunchLockoutStatusError } = (0, hooks_1.useMissedPunchLockoutStatus)({
        employeeId: associateInfo.employeeId,
        shouldFetch: isAddPunch && !addPunchLockedOutStatus,
        usageLocation: consts_1.featureNames.PUNCH_WORKFLOW_FEATURE
    });
    const missedPunchLockoutStatus = addPunchLockedOutStatus ||
        (associateAipLockoutStatus === null || associateAipLockoutStatus === void 0 ? void 0 : associateAipLockoutStatus.associateAipLockoutStatus);
    (0, react_1.useEffect)(() => {
        if (!isMissedPunchLockoutStatusLoading && !addPunchLockedOutStatus) {
            setAddPunchLockedOutStatus(missedPunchLockoutStatus);
        }
    }, [
        isMissedPunchLockoutStatusLoading,
        addPunchLockedOutStatus,
        missedPunchLockoutStatus,
        setAddPunchLockedOutStatus
    ]);
    let lockoutStatus = {
        type: PunchModalTypes_1.LockoutStatusType.OK,
        message: null
    };
    if (isAddPunch) {
        if (missedPunchLockoutStatus === PunchModalTypes_1.LockoutStatusType.WARNING) {
            lockoutStatus = {
                type: missedPunchLockoutStatus,
                message: t('time_and_attendance_PunchModal_MissedPunchAIPLockout_Warning')
            };
        }
        else if (missedPunchLockoutStatus === PunchModalTypes_1.LockoutStatusType.LOCKED_OUT) {
            lockoutStatus = {
                type: missedPunchLockoutStatus,
                message: t('time_and_attendance_PunchModal_MissedPunchAIPLockout_Block')
            };
            setTotalSteps(3);
            setIsActionable(false);
        }
    }
    let punchDetails;
    if (isEditPunch && selectedPunchTime) {
        const lastUpdatedDate = luxon_1.DateTime.fromISO(selectedPunchTime.punchDetails.lastUpdatedDateTime.timestamp).toFormat('LLLL dd, yyyy');
        const lastUpdatedTime = luxon_1.DateTime.fromISO(selectedPunchTime.punchDetails.lastUpdatedDateTime.timestamp).toLocaleString(luxon_1.DateTime.TIME_SIMPLE);
        const hasBeenEdited = JSON.stringify((_a = selectedPunchTime.punchDetails) === null || _a === void 0 ? void 0 : _a.createdDateTime) !==
            JSON.stringify(selectedPunchTime.punchDetails.lastUpdatedDateTime);
        const punchSourceText = PunchDetailsModalTypes_1.punchSourceMap[(_b = selectedPunchTime.punchDetails) === null || _b === void 0 ? void 0 : _b.punchSourceSystem];
        const punchSourceAndSiteIdText = !!punchSourceText && ((_d = (_c = selectedPunchTime.punchDetails) === null || _c === void 0 ? void 0 : _c.punchLocation) === null || _d === void 0 ? void 0 : _d.siteId)
            ? `${punchSourceText} | ${(_f = (_e = selectedPunchTime.punchDetails) === null || _e === void 0 ? void 0 : _e.punchLocation) === null || _f === void 0 ? void 0 : _f.siteId}`
            : punchSourceText ||
                ((_h = (_g = selectedPunchTime.punchDetails) === null || _g === void 0 ? void 0 : _g.punchLocation) === null || _h === void 0 ? void 0 : _h.siteId);
        const getSubmitterContent = (source, submitter) => {
            if (PunchDetailsModalTypes_1.showSubmitterResult.includes(source)) {
                return submitter;
            }
            else if (PunchDetailsModalTypes_1.showSystemInfo.includes(source)) {
                return t('time_and_attendance_PunchDetailsModal_PunchSource_System');
            }
            else if (PunchDetailsModalTypes_1.showUserAlias.includes(source)) {
                return t('time_and_attendance_PunchDetailsModal_PunchAction_Self');
            }
            else {
                return '';
            }
        };
        const submitterString = getSubmitterContent((_j = selectedPunchTime.punchDetails) === null || _j === void 0 ? void 0 : _j.punchSourceSystem, selectedPunchTime.punchDetails.submitter.submitter);
        const getAuditHistoryTitle = () => {
            if (submitterString && hasBeenEdited) {
                return t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_EditedBy');
            }
            else if (submitterString) {
                return t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_AddedBy');
            }
            else if (hasBeenEdited) {
                return t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_EditedOn');
            }
            else {
                return t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_AddedOn');
            }
        };
        const getAuditHistoryText = () => {
            if (submitterString) {
                return t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_AliasOnDateAtTime', {
                    alias: submitterString,
                    date: lastUpdatedDate,
                    time: lastUpdatedTime
                });
            }
            else {
                return t('time_and_attendance_DateAtTime', {
                    date: lastUpdatedDate,
                    time: lastUpdatedTime
                });
            }
        };
        punchDetails = [
            {
                label: t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_Punch'),
                value: t('time_and_attendance_DateAtTime', {
                    date: luxon_1.DateTime.fromISO(selectedPunchTime.punchDateTime.timestamp).toFormat('LLLL dd, yyyy'),
                    time: luxon_1.DateTime.fromISO(selectedPunchTime.punchDateTime.timestamp).toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
                })
            },
            {
                label: t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_Location'),
                value: punchSourceAndSiteIdText
            },
            {
                label: getAuditHistoryTitle(),
                value: getAuditHistoryText()
            }
        ];
    }
    const inputLabel = t('time_and_attendance_PunchWorkflow_EditOrAddPunchStep_WhatTime');
    const toggleMilitaryTime = () => {
        setUseMilitaryTime(!useMilitaryTime);
        setPunchTime('');
        setNewPunchTime('');
    };
    return {
        isAddPunch,
        isEditPunch,
        punchDetails,
        inputLabel,
        punchDate,
        setPunchDate,
        punchTime,
        setPunchTime,
        hasInputError,
        setHasInputError,
        inputErrorMessage,
        setInputErrorMessage,
        useMilitaryTime,
        toggleMilitaryTime,
        isLoading: isMissedPunchLockoutStatusLoading,
        error: missedPunchLockoutStatusError,
        lockoutStatus
    };
};
exports.useEditPunchStep = useEditPunchStep;
